import React, { FC } from 'react';

import ServicesForm from '../ServicesView/ServicesForm';

const ServicesTab: FC = () => {
  return <ServicesForm hideDisabledServices hideServiceSelection disabled />;
};

export default ServicesTab;
